var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarReadingTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1184 4.01071L9.27556 0.167857C9.16842 0.0607143 9.02377 0 8.87199 0H1.28627C0.970201 0 0.714844 0.255357 0.714844 0.571429V15.4286C0.714844 15.7446 0.970201 16 1.28627 16H12.7148C13.0309 16 13.2863 15.7446 13.2863 15.4286V4.41607C13.2863 4.26429 13.2256 4.11786 13.1184 4.01071ZM11.9684 4.67857H8.6077V1.31786L11.9684 4.67857ZM12.0006 14.7143H2.00056V1.28571H7.39342V5.14286C7.39342 5.34177 7.47243 5.53254 7.61309 5.67319C7.75374 5.81384 7.9445 5.89286 8.14342 5.89286H12.0006V14.7143Z",
    fill: "black",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarReadingTest);
export default __webpack_public_path__ + "static/media/sidebar-reading-test.978aa7a9dbdd52933169dfe605dc8e6c.svg";
export { ForwardRef as ReactComponent };